export default "__VITE_ASSET__kdnMwUKT__"